// extracted by mini-css-extract-plugin
export var notificationHost = "_lj-0";